import videojs from 'video.js';

const formatDigit = (digit) => {
	let is_kilo = digit * 1 >=1000;
	if (is_kilo) digit = Math.trunc(digit * 1 / 1000);

	let res = digit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
	if (is_kilo) res +='K';
	return res;
}

const storage = () => {
	return {
		set: (key, val) => {
			window.localStorage && localStorage.setItem(key, val);
		},
		get: (key) => {
			return window.localStorage && localStorage.getItem(key);
		}
	};
};

const makeRequest = (link) => {
    let p = new Promise((resolve, reject) => {
      videojs.xhr({uri: link, withCredentials: true}, function (err, resp) {
        let res;
        try {
          res = resp && resp.rawRequest && resp.rawRequest.response &&
            JSON.parse(resp.rawRequest.response);
        } catch (json_err) {
          err = json_err;
        }
        if (resp.statusCode !== 200 || !res) {
          reject(err);
        } else if (res.error) {
          reject(res.error);
        } else {
          resolve(res);
        }
      });
    });

    return p;
};

var utils = {
  formatDigit: formatDigit,
  storage: storage,
  makeRequest: makeRequest
};

export default utils;
